/** @jsx jsx */

import { jsx } from '@balance-web/core';
import { useTheme } from '@balance-web/theme';

import type { CheckboxSize } from './types';

const sizeToScaleKey = {
  small: 'xxsmall',
  medium: 'xsmall',
} as const;

export const CheckboxIndicator = ({
  size = 'medium',
  ...props
}: {
  children?: React.ReactNode;
  size?: CheckboxSize;
}) => {
  const { palette, radii, sizing } = useTheme();
  const resolvedSize = sizing[sizeToScaleKey[size]];

  return (
    <div
      css={{
        alignItems: 'center',
        backgroundColor: palette.formControl.background,
        border: `2px solid #DDDEE9`,
        borderRadius: radii.xsmall,
        boxSizing: 'border-box',
        color: palette.formControl.background,
        cursor: 'pointer',
        display: 'flex',
        flexShrink: 0,
        height: resolvedSize,
        justifyContent: 'center',
        width: resolvedSize,
        position: 'relative',

        // For the outter circle on hover
        '::after': {
          content: '""',
          display: 'block',
          width: '190%',
          height: '190%',
          borderRadius: 9999,
          background: '#efefef',
          opacity: 0,
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          zIndex: -1,
        },

        'input:hover + &': {
          backgroundColor: '#efefef',
          '::after': {
            opacity: 0.7,
          },
        },

        'input + & svg': {
          opacity: 0,
        },
        'input:checked + & svg': {
          opacity: 1,
        },

        'input:checked + &, input:indeterminate + &': {
          backgroundColor: palette.formControl.interaction,
          borderColor: palette.formControl.interaction,
          color: palette.formControl.foregroundChecked,
        },
        'input:disabled + &': {
          backgroundColor: palette.formControl.border,
          borderColor: palette.formControl.border,
          color: palette.formControl.border,
          cursor: 'default',
        },
        'input:checked:disabled + &': {
          color: palette.formControl.foregroundDisabled,
        },
      }}
      {...props}
    />
  );
};
